import React, { useMemo, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Autosuggest from 'react-autosuggest'
import { useEditOrderSvc } from '../service'
import { Category, Item, Menu } from '../../model-menus'

export type SuggestItem = SuggestMenuItem | SuggestNewItem
export enum SuggestType { NewItem, MenuItem }
export interface SuggestNewItem {
  kind: SuggestType.NewItem
  name: string
}
export interface SuggestMenuItem {
  kind: SuggestType.MenuItem
  id: number
  name: string
  menuName: string
  menuId: number
  categoryName: string
  categoryId: number
  price: number
}

export function FormMenuItemLookup(props: { name: string }): JSX.Element {
  const { register, control, watch, formState: { errors }, setError, clearErrors, setFocus } = useFormContext()

  const editOrderSvc = useEditOrderSvc()

  const allMenuItems = useMemo(() =>
    editOrderSvc.getMenus().reduce((items: SuggestItem[], menu: Menu): SuggestItem[] =>
      menu.categories.reduce((items: SuggestItem[], category: Category): SuggestItem[] =>
        category.items.reduce((items: SuggestItem[], item: Item): SuggestItem[] => [...items, {
          kind: SuggestType.MenuItem,
          id: item.id,
          name: item.name,
          menuName: menu.name,
          menuId: menu.id,
          categoryName: category.name,
          categoryId: category.id,
          price: item.price,
        }], items), items), [])
    , [editOrderSvc])

  const renderMenuItem = (s: SuggestItem): JSX.Element =>
    <div>
      <div key="name"><strong>{s.name}</strong></div>
      {s.kind == SuggestType.MenuItem && <div key="path" className="text-muted">{s.menuName}, {s.categoryName}</div>}
      {s.kind == SuggestType.NewItem && <div key="path" className="text-muted">Select to confirm new item not in menu</div>}
    </div>


  const [autocompleteValue, onChangeAutocompleteValue] = useState<string>('')
  const [suggestions, setSuggestions] = useState<SuggestItem[]>([])

  const itemName = watch(props.name)

  return (<>
    <div className="form-group">
      <label htmlFor={props.name}>Item Name:</label>
      <Controller
        control={control}
        name={props.name}
        rules={{ required: { value: true, message: "Please select a menu item or enter the name of a new item and select it" } }}
        render={({ field: { onChange, onBlur, name, ref }, }) => (
          <Autosuggest
            suggestions={suggestions}
            renderSuggestion={renderMenuItem}
            onSuggestionSelected={(_event: any, data: any) => {
              onChange(data.suggestion)
            }}
            onSuggestionsFetchRequested={({ value }: { value: string }) => {
              const suggestions = allMenuItems.filter(({ name }) => name.toLowerCase().startsWith(value.toLowerCase()))
              suggestions.length !== 0 ? setSuggestions(suggestions) : setSuggestions([{ kind: SuggestType.NewItem, name: value }])
            }}
            onSuggestionsClearRequested={() => setSuggestions([])}
            ref={ref}
            getSuggestionValue={(i: SuggestItem) => i.name}
            inputProps={{
              name,
              onBlur,
              value: autocompleteValue,
              placeholder: 'search items or enter a new item name',
              onChange: (_: any, { newValue }: { newValue: string }) => { onChangeAutocompleteValue(newValue) }
            }} />
        )}
      />
      {errors && errors[props.name] && <span className="text-danger">{errors[props.name].message}</span>}
    </div>


    {itemName && itemName.kind == SuggestType.NewItem && <>
      <div className="form-group">
        <label htmlFor="menu_name">Menu Name:</label>
        <input
          id="menu_name"
          className="form-control input input-small"
          style={errors && errors.menu_name ? { color: 'red' } : {}}
          type="text"
          {...register('menu_name', {
            required: 'is required',
          })}
        />
        {errors && errors.menu_name && <span className="text-danger">{errors.menu_name.message}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="category_name">Category Name:</label>
        <input
          id="category_name"
          className="form-control input input-small"
          style={errors && errors.category_name ? { color: 'red' } : {}}
          type="text"
          {...register('category_name', {
            required: 'is required',
          })}
        />
        {errors && errors.category_name && <span className="text-danger">{errors.category_name.message}</span>}
      </div></>}
  </>)
}
